import styles from './InputItemLight.module.css'
import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";


export interface IRefInputItemLight {
    validate: () => boolean;
}

interface IInputItemLightPops
{
    val?:any
    type?:"string"|"number"|"boolean"
    onChange?: (val:string, typedVal: any)=>void
    onBlur?:(val:string, typedVal: any)=>void
    title?:string
    mode:string
    inputType?:"numeric"|"text"
    minWidth?: string
    maxWidth?: string
    maxLen?:number
    placeHolder?:string
    titleColNumber?:number
    classTitle?:string
    classInput?:string
    regExp?:RegExp
    canEmpty?:boolean
    onlySpace?:boolean
    info?:string
    trim?:boolean
    readonly?:boolean



}
const InputItemLight = forwardRef<IRefInputItemLight,IInputItemLightPops>(({onlySpace,onBlur,classInput,trim,titleColNumber,maxWidth,minWidth,classTitle, title, inputType,placeHolder,mode, maxLen, canEmpty, val, type, regExp, info, onChange}:IInputItemLightPops, ref)=>{
    const [localVal, setLocalVal]= useState<string>("")
    const refInput = useRef<HTMLInputElement >(null)
    const [invalid, setInvalid] = useState(false)
    const [readonly, setReadonly] = useState(true)

    const [marginOpt, setMarginOpt]= useState(0)

    let colTitle = 6
    let colVal = 6
    if(titleColNumber!==undefined && titleColNumber <= 12)
    {
        colTitle = titleColNumber
        colVal = 12 - colTitle
    }
    const localInputType = inputType ? inputType : "text"
    const localType = type ? type : "string"

    useImperativeHandle(ref, () => ({
        validate : validateLocalVal,
    }));


    useEffect(()=>{
        if(! mode) return
        if(mode?.match(/e/ui))setReadonly(false)

    }, [mode])


    useEffect(()=>{
        setInvalid(false)
        if(val === undefined) return
        if(val === null)
        {
            setLocalVal("")
            return;
        }
        setLocalVal(val?.toString())
    },[val])



    const parseToType = (val: string):any =>{
        if(!localType && val === undefined) return null
        if(val === null) return null
        if(localType?.match(/string/ui)) return val?.toString()
        if(localType?.match(/number/ui)) return Number(val)
        if(localType?.match(/boolean/ui)) return val ? true : false
        return null
    }

    const buildMode = ()=>{
        const x = new Array<string>()
        let marginCnt = 0
        for(let i=0 ; i< mode?.length ; i++)x?.push(mode?.substring(i,i+1))
        const line = x?.map((item,idx)=>{
            if(item?.match(/i/ui))
            {
                marginCnt++
                return(
                    <div key={idx} onClick={()=> {
                    } }>
                        <i key={idx} className='bx bx-help-circle'/>
                    </div>
                )

            }
            if(item?.match(/e/ui))
            {
                marginCnt++
                return(
                    <div key={idx} onClick={()=>{
                        if(refInput.current)
                        {
                            refInput.current.focus()
                            refInput.current.select()
                        }

                    } }>
                        <i key={idx} className='bx bx-edit-alt'/>
                    </div>
                )

            }
            return null

        })
        //setMarginOpt(marginCnt * 15)
        return(
            <div className={styles.optCont}>{line}</div>
        )
    }


    const validateLocalVal = ():boolean =>
    {
        if(! regExp)return true
        if(localVal === undefined) return true
        if(canEmpty && localVal?.length === 0) return true
        if(! localVal?.match(regExp))return false
        return true

    }

    const validateRegExp = ()=>{
        setInvalid(!validateLocalVal())
    }


 //   console.log("local", localInputType)
    return(

        <div className={styles.mainCont} style={{
            maxWidth: maxWidth !== undefined ? maxWidth :"inherit",
            minWidth: minWidth !== undefined ? minWidth :"inherit"
        }}>
            <div className={["row w-100 "].join(' ')}>
                <div className={[`d-flex col-md-${colTitle} px-0`, colTitle === 0 ? "d-none" : ""].join(' ')}>
                    <div className={[styles.title, classTitle ? classTitle : ""].join(' ')}>{title ? title : ""}</div>
                </div>
                <div className={[`d-flex nogu col-md-${colVal} px-0`].join(' ')}>
                    <div className={styles.inpCont}>
                        <div className={styles.inpOptCont}>
                            <input
                                className={["form-control form-control-sm", classInput ? classInput : ""].join(' ')}
                                inputMode={localInputType}
                                value={localVal}
                                maxLength={maxLen ? maxLen : undefined}
                                placeholder={placeHolder !== undefined ? placeHolder : undefined}
                                readOnly={readonly}
                                onChange={(e)=>{
                                    let x = e?.target?.value?.toString()
                                    if(trim)x = x.trim()
                                    if(onlySpace !== undefined && !onlySpace && x?.match(/^\s+$/ui))
                                    {
                                        x = x?.trim()
                                    }
                                    setLocalVal(x)
                                    if(onChange)onChange(x, parseToType(x))
                                    setInvalid(false)
                                } }
                                onBlur={()=>{
                                    validateRegExp()
                                    if(onBlur)onBlur(localVal, parseToType(localVal))
                                }}

                                ref={refInput}/>

                            {buildMode()}

                        </div>
                        {invalid && <div className={styles.incText}>Не корректное значение</div>}
                    </div>
                </div>
            </div>


        </div>
    )


})

export default InputItemLight